import React from 'react';
import PropTypes from 'prop-types';
import { ScrollAnimationsContext } from './ScrollAnimationsProvider';
import { getChargesAnywhereClassNames } from '../../helpers/starterKitClassNamesHelper';

export const ChargesAnywhere = ({
  chargesTextBlock,
  podImageUrl,
  deviceImageUrl,
  laptopImageUrl,
  usbImageUrl,
}) => {
  const chargesAnywhereTrigger = React.useRef(null);
  const chargesAnywhereGapSceneTrigger = React.useRef(null);
  const pinElementRef = React.useRef(null);
  const { chargesAnywhereScene, chargesAnywhereGapScene } = React.useContext(
    ScrollAnimationsContext
  );

  React.useEffect(() => {
    chargesAnywhereScene
      .triggerElement(chargesAnywhereTrigger.current)
      .setPin(pinElementRef.current, { pushFollowers: false });
    chargesAnywhereGapScene.triggerElement(
      chargesAnywhereGapSceneTrigger.current
    );
    return;
  }, [chargesAnywhereScene, chargesAnywhereGapScene]);

  const {
    textAnimationClass,
    laptopAnimationClass,
    usbAnimationClass,
    deviceAnimationClass,
    podAnimationClass,
    deviceClickAnimation,
  } = getChargesAnywhereClassNames({ chargesAnywhereScene });

  return (
    <>
      <div id="chargesAnywhereTrigger" ref={chargesAnywhereTrigger} />
      <div className="charges-anywhere-container">
        <div
          id="chargesAnywhere"
          ref={pinElementRef}
          style={{ height: chargesAnywhereScene.duration() }}
        >
          <div className="charges-anywhere-wrapper">
            <div className="charges-anywhere">
              <div
                className={`charges-anywhere__text col-xs-8 first-sm col-sm-6 col-md-8 ${textAnimationClass}`}
                dangerouslySetInnerHTML={{ __html: chargesTextBlock }}
              />
              <div className="charges-anywhere__image-section col-xs-4 col-sm-6">
                <div className={`${deviceClickAnimation}`}>
                  <img
                    className={`charges-anywhere__image--pod ${podAnimationClass}`}
                    src={podImageUrl}
                  />
                  <img
                    className={`charges-anywhere__image--device ${deviceAnimationClass}`}
                    src={deviceImageUrl}
                  />
                </div>
                <img
                  className={`charges-anywhere__image--usb ${usbAnimationClass}`}
                  src={usbImageUrl}
                />
              </div>
              <div
                className={`charges-anywhere__image-section--bottom ${laptopAnimationClass}`}
              >
                <img
                  className="charges-anywhere__image--laptop"
                  src={laptopImageUrl}
                />
              </div>
            </div>
          </div>
        </div>
      </div>

      <div>
        <div
          id="chargesAnywhereGapSceneTrigger"
          ref={chargesAnywhereGapSceneTrigger}
        />
        <div
          id="chargesAnywhereGapScene"
          style={{ height: `${chargesAnywhereGapScene.duration()}px` }}
        />
      </div>
    </>
  );
};

ChargesAnywhere.propTypes = {
  chargesTextBlock: PropTypes.string.isRequired,
  podImageUrl: PropTypes.string.isRequired,
  deviceImageUrl: PropTypes.string.isRequired,
  laptopImageUrl: PropTypes.string.isRequired,
  usbImageUrl: PropTypes.string.isRequired,
};
